import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { format } from "date-fns";

import { getNpsResult } from "../../../../services/nps/functions";

import Typography from "../../../../components/Typography";

import "./nps-level.css";
import { getNpsResultCall } from "../../../../actions";

export default function NpsLevel({
  setLevel = () => {},
  setLoadingPieChartData = () => {},
}) {
  const filtersDashboard = useSelector((state) => state.npsfilters);
  const agentDashboardFilter = useSelector(
    (state) => state.agentDashboardFilter
  );

  const [initialDate, setInitialDate] = useState(
    agentDashboardFilter.initialDateAgenteScreen
  );
  const [finalDate, setFinalDate] = useState(
    agentDashboardFilter.finalDateAgentScreen
  );
  const [promoters, setPromoters] = useState(0);
  const [neutral, setNeutral] = useState(0);
  const [detractor, setDetractor] = useState(0);
  const [loading, setLoading] = useState(false);
  const [npsLevel, setNpsLevel] = useState(null);
  const [dispareFilter, setDispareFilter] = useState(false);
  const [npsNote, setNpsNote] = useState(null);

  const getNPSNote = () => {
    if (promoters && detractor) {
      const promotersQtd = Number(promoters.qtde) ? Number(promoters.qtde) : 0;
      const detractorsQtd = Number(detractor.qtde) ? Number(detractor.qtde) : 0;

      const total = promotersQtd + detractorsQtd;

      const nps = total
        ? (((promotersQtd - detractorsQtd) / total) * 100).toFixed(2)
        : 100;

      setNpsNote(nps);
    } else if (promoters) {
      setNpsNote("100.00");
    } else if (detractor) {
      setNpsNote("-100.00");
    }
    /*
    if (promoters) {
      if (promoters.percentage || promoters.percentage === 0) {
        if (detractor) {
          if (detractor.percentage || detractor.percentage === 0) {
            setNpsNote(promoters.percentage - detractor.percentage);
          } else {
            setNpsNote(promoters.percentage);
          }
        } else {
          setNpsNote(promoters.percentage);
        }
      } else {
        setNpsNote(null);
      }
    } else {
      setNpsNote(null);
    }
    */
  };

  const renderContent = (label, percentage) => {
    if (percentage <= 5) {
      return <span className="percentage">{`${percentage}%`}</span>;
    } else {
      return (
        <span className="label-and-percentage">
          <span className="label">{label}</span>
          <span className="percentage">{`${percentage}%`}</span>
        </span>
      );
    }
  };

  async function getNpsLevel() {
    setLoading(true);
    setLoadingPieChartData(true);

    const response = await getNpsResultCall(
      format(
        new Date(agentDashboardFilter.initialDateAgenteScreen),
        "yyyy-MM-dd"
      ),
      format(new Date(agentDashboardFilter.finalDateAgentScreen), "yyyy-MM-dd"),
      agentDashboardFilter.channelSelectedAgentScreen
        .map((option) => option.id)
        .join(),
      agentDashboardFilter.avaliationSelectedAgentScreen
        .map((option) => option.id)
        .join()
    );

    if (response && response.status !== 200) return;

    if (response && response.status === 200) {
      const data = response.data;

      if (data.length) {
        const total = data
          .map((datum) => Number(datum.qtde))
          .reduce((a, b) => a + b);
        let promotersData = data.find((datum) => datum.tipo === "promotor");
        let neutralData = data.find((datum) => datum.tipo === "neutro");
        let detractorData = data.find((datum) => datum.tipo === "detrator");

        let promoterQtd = 0;
        let neutralQtd = 0;
        let detractorQtd = 0;
        // let detractorData = 100;
        if (promotersData) {
          promotersData.percentage = Number(
            ((Number(promotersData.qtde) / total) * 100).toFixed(2)
          );

          promoterQtd = Number(promotersData.qtde)
            ? Number(promotersData.qtde)
            : 0;
        }
        if (neutralData) {
          neutralData.percentage = Number(
            ((Number(neutralData.qtde) / total) * 100).toFixed(2)
          );

          neutralQtd = Number(neutralData.qtde) ? Number(neutralData.qtde) : 0;
        }
        if (detractorData) {
          detractorData.percentage = Number(
            ((Number(detractorData.qtde) / total) * 100).toFixed(2)
          );

          detractorQtd = Number(detractorData.qtde)
            ? Number(detractorData.qtde)
            : 0;
        }

        const totalToCalcNps = promoterQtd + detractorQtd + neutralQtd;
        const calcNps = totalToCalcNps
          ? (((promoterQtd - detractorQtd) / totalToCalcNps) * 100).toFixed(2)
          : "0.00";

        setNpsLevel(response.data);
        setLevel(calcNps ? calcNps : 0);
        setPromoters(promotersData ? promotersData : 0);
        setNeutral(neutralData ? neutralData : 0);
        setDetractor(detractorData ? detractorData : 0);
        setNpsNote(calcNps);
      } else {
        setLevel(0);
        setPromoters(false);
        setNeutral(false);
        setDetractor(false);

        setNpsNote(null);
      }
      setDispareFilter(true);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }

    setLoading(false);
    setLoadingPieChartData(false);
  }

  /*
  useEffect(() => {
    getNpsLevel();
    setDispareFilter(true);
  }, []);

  useEffect(() => {
    if (filtersDashboard.active && dispareFilter) {
      getNpsLevel();
    }
  }, [filtersDashboard]);
  */
  useEffect(() => {
    if (!!agentDashboardFilter) {
      getNpsLevel();
    }
  }, [agentDashboardFilter]);
  /*
  useEffect(() => {
    getNPSNote();
  }, [promoters, detractor]);
  */
  return (
    <section className="nps-level">
      <div className="nps-level__bar">
        {promoters ? (
          <div
            style={{ width: `${promoters ? promoters.percentage : 0}%` }}
            className={`promoter ${
              !neutral && !detractor ? "full-border" : ""
            }`}
          >
            {renderContent("Promotores", promoters.percentage)}
          </div>
        ) : (
          ""
        )}
        {neutral ? (
          <div
            style={{ width: `${neutral ? neutral.percentage : 0}%` }}
            className={`neutral ${
              !promoters && detractor ? "first-border" : ""
            } ${promoters && !detractor ? "last-border" : ""} ${
              !promoters && !detractor ? "full-border" : ""
            }`}
          >
            {renderContent("Neutro", neutral.percentage)}
          </div>
        ) : (
          ""
        )}
        {detractor ? (
          <div
            style={{ width: `${detractor ? detractor.percentage : 0}%` }}
            className={`detractor ${
              !promoters && !neutral ? "full-border" : ""
            }`}
          >
            {renderContent("Detrator", detractor.percentage)}
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="nps-level__note">
        <Typography.H5
          weight="400"
          color="gray-180"
          className="nps-level__note__text"
        >
          Nota
        </Typography.H5>

        <Typography.H1
          weight="700"
          color="gray-180"
          className="nps-level__note__number"
        >
          {npsNote}
        </Typography.H1>
      </div>
    </section>
  );
}
